export const TID = {
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  sidebarDashboard: "sidebar-dashboard",
  sidebarCompanies: "sidebar-companies",
  sidebarWorkers: "sidebar-workers",
  sidebarSites: "sidebar-sites",
  sidebarEquipment: "sidebar-equipment",
  sidebarScadenzario: "sidebar-scadenzario",
  sidebarShares: "sidebar-shares",
  sidebarAudit: "sidebar-audit",
  logout: "logout-button",
  addCompany: "add-company-button",
  companySubmit: "company-submit-button",
  addWorker: "add-worker-button",
  addSite: "add-site-button",
  addEquipment: "add-equipment-button",
  uploadDoc: "upload-doc-button",
  createShare: "create-share-button",
};
